var map = {
	"./Admins/Create": [
		8135,
		660,
		135
	],
	"./Admins/Create.vue": [
		8135,
		660,
		135
	],
	"./Admins/Edit": [
		4095,
		660,
		95
	],
	"./Admins/Edit.vue": [
		4095,
		660,
		95
	],
	"./Admins/Index": [
		1655,
		660,
		655
	],
	"./Admins/Index.vue": [
		1655,
		660,
		655
	],
	"./Articles/Create": [
		1657,
		660,
		657
	],
	"./Articles/Create.vue": [
		1657,
		660,
		657
	],
	"./Articles/Edit": [
		7848,
		660,
		848
	],
	"./Articles/Edit.vue": [
		7848,
		660,
		848
	],
	"./Articles/Index": [
		2365,
		660,
		365
	],
	"./Articles/Index.vue": [
		2365,
		660,
		365
	],
	"./Auth/Login": [
		5508,
		660,
		508
	],
	"./Auth/Login.vue": [
		5508,
		660,
		508
	],
	"./Auth/ResetPassword": [
		9554,
		660,
		554
	],
	"./Auth/ResetPassword.vue": [
		9554,
		660,
		554
	],
	"./Banners/Create": [
		7667,
		660,
		667
	],
	"./Banners/Create.vue": [
		7667,
		660,
		667
	],
	"./Banners/Edit": [
		8427,
		660,
		427
	],
	"./Banners/Edit.vue": [
		8427,
		660,
		427
	],
	"./Banners/Index": [
		4850,
		660,
		850
	],
	"./Banners/Index.vue": [
		4850,
		660,
		850
	],
	"./Calls/Edit": [
		1459,
		660,
		459
	],
	"./Calls/Edit.vue": [
		1459,
		660,
		459
	],
	"./Calls/Index": [
		6421,
		660,
		421
	],
	"./Calls/Index.vue": [
		6421,
		660,
		421
	],
	"./CategoriesArticles/Create": [
		2109,
		660,
		490
	],
	"./CategoriesArticles/Create.vue": [
		2109,
		660,
		490
	],
	"./CategoriesArticles/Edit": [
		7020,
		660,
		20
	],
	"./CategoriesArticles/Edit.vue": [
		7020,
		660,
		20
	],
	"./CategoriesArticles/Index": [
		3371,
		660,
		371
	],
	"./CategoriesArticles/Index.vue": [
		3371,
		660,
		371
	],
	"./Faqs/Create": [
		5468,
		660,
		468
	],
	"./Faqs/Create.vue": [
		5468,
		660,
		468
	],
	"./Faqs/Edit": [
		1698,
		660,
		698
	],
	"./Faqs/Edit.vue": [
		1698,
		660,
		698
	],
	"./Faqs/Index": [
		1531,
		660,
		531
	],
	"./Faqs/Index.vue": [
		1531,
		660,
		531
	],
	"./Footer/Index": [
		476,
		660,
		476
	],
	"./Footer/Index.vue": [
		476,
		660,
		476
	],
	"./LangStrings/Create": [
		2186,
		660,
		186
	],
	"./LangStrings/Create.vue": [
		2186,
		660,
		186
	],
	"./LangStrings/Edit": [
		7067,
		660,
		67
	],
	"./LangStrings/Edit.vue": [
		7067,
		660,
		67
	],
	"./LangStrings/Index": [
		6763,
		660,
		763
	],
	"./LangStrings/Index.vue": [
		6763,
		660,
		763
	],
	"./Menu/Create": [
		8165,
		660,
		165
	],
	"./Menu/Create.vue": [
		8165,
		660,
		165
	],
	"./Menu/Edit": [
		4491,
		660,
		491
	],
	"./Menu/Edit.vue": [
		4491,
		660,
		491
	],
	"./Menu/Index": [
		9348,
		660,
		348
	],
	"./Menu/Index.vue": [
		9348,
		660,
		348
	],
	"./Pages/Edit-404": [
		3024,
		660,
		24
	],
	"./Pages/Edit-404.vue": [
		3024,
		660,
		24
	],
	"./Pages/Edit-about": [
		2956,
		660,
		956
	],
	"./Pages/Edit-about.vue": [
		2956,
		660,
		956
	],
	"./Pages/Edit-blogs": [
		755,
		660,
		755
	],
	"./Pages/Edit-blogs.vue": [
		755,
		660,
		755
	],
	"./Pages/Edit-brands": [
		8997,
		660,
		997
	],
	"./Pages/Edit-brands.vue": [
		8997,
		660,
		997
	],
	"./Pages/Edit-catalog": [
		6381,
		660,
		381
	],
	"./Pages/Edit-catalog.vue": [
		6381,
		660,
		381
	],
	"./Pages/Edit-contact": [
		2627,
		660,
		627
	],
	"./Pages/Edit-contact.vue": [
		2627,
		660,
		627
	],
	"./Pages/Edit-faq": [
		2460,
		660,
		460
	],
	"./Pages/Edit-faq.vue": [
		2460,
		660,
		460
	],
	"./Pages/Edit-faqs": [
		6195,
		660,
		195
	],
	"./Pages/Edit-faqs.vue": [
		6195,
		660,
		195
	],
	"./Pages/Edit-home": [
		9595,
		660,
		595
	],
	"./Pages/Edit-home.vue": [
		9595,
		660,
		595
	],
	"./Pages/Index": [
		8931,
		660,
		931
	],
	"./Pages/Index.vue": [
		8931,
		660,
		931
	],
	"./SeoPages/Edit": [
		4851,
		660,
		851
	],
	"./SeoPages/Edit.vue": [
		4851,
		660,
		851
	],
	"./SeoPages/Index": [
		8672,
		660,
		672
	],
	"./SeoPages/Index.vue": [
		8672,
		660,
		672
	],
	"./Settings/Create": [
		5811,
		660,
		811
	],
	"./Settings/Create.vue": [
		5811,
		660,
		811
	],
	"./Settings/Edit": [
		7331,
		660,
		331
	],
	"./Settings/Edit.vue": [
		7331,
		660,
		331
	],
	"./Settings/Index": [
		3086,
		660,
		86
	],
	"./Settings/Index.vue": [
		3086,
		660,
		86
	],
	"./Slider/Index": [
		5184,
		660,
		184
	],
	"./Slider/Index.vue": [
		5184,
		660,
		184
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3928;
module.exports = webpackAsyncContext;